import { Divider, Grid, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import globalStyles from "../../assets/styles/global.module.scss";
import style from "../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import workFlowGlobalStyles from "../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowGlobal.module.scss";
import clsx from 'clsx'
import { condition_group } from '../../models/axiosModel';
import GlobalTooltip from './tooltip/globalTooltip';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconsColor from './iconsColor';
import QRCode from 'react-qr-code';
import { getChannelQrText } from '../../utils/constants';
import { CHATBOT_CHANNEL_NAME } from '../../pages/ruleBasedInbox/channelConstants';

interface QrCodePopupProps {
    phoneNumberQR: string,
    flagShowTriggerKeyword?: boolean,
    conditionGroup?: condition_group | null,
    channelName?: string,
}

const QrCodePopup: React.FC<QrCodePopupProps> = ({ phoneNumberQR, flagShowTriggerKeyword, conditionGroup, channelName = CHATBOT_CHANNEL_NAME.WHATSAPP }) => {
    
    const svgRef = useRef<HTMLDivElement | null>(null);
    const [copyText, setCopyText] = useState<string>("Copy");

    const downloadQRCode = () => {
        if (!svgRef.current) return;

        const svg = svgRef.current.querySelector('svg');
        if (!svg) return;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return;

        const svgData = new XMLSerializer().serializeToString(svg);
        const img = new Image();
        const svgSize = svg.getBoundingClientRect();
        canvas.width = svgSize.width;
        canvas.height = svgSize.height;

        img.onload = () => {
            ctx.drawImage(img, 0, 0);
            const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
            const downloadLink = document.createElement('a');
            downloadLink.href = pngUrl;
            downloadLink.download = `${phoneNumberQR}.png`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        };

        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
    }

    const handleCopy = () => {
        setCopyText("Copied!");
    };

    const onMouseLeaveOfCopy = () => {
        setCopyText("Copy");
    }

    const getTriggerKeyword = () => {
        if(flagShowTriggerKeyword){
            if(conditionGroup){
                return conditionGroup?.condition_values?.[0];
            }
            return "Hi";
        }
        return "";
    }

    const qrLink = getChannelQrText(phoneNumberQR, channelName, getTriggerKeyword());

    return (
        <>
            <Grid item xs={12}>
                <Grid container className={clsx(globalStyles.flexColumn, globalStyles.justifyCenter)}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>
                                {`Scan QR Code to view in ${channelName}`}
                            </Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} /> 

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={1} alignItems={"center"} justifyContent={"center"}>

                                {flagShowTriggerKeyword && 
                                    <Grid item xs={12}> 
                                        <Grid container gap={1} alignItems={"center"}>
                                            <Grid item>
                                                <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                                    {conditionGroup ? `Trigger Keywords:` : `Default Chatbot`}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Grid container gap={1} alignItems={"center"}>
                                                    {conditionGroup ?
                                                        conditionGroup?.condition_values?.map((value: string) => {
                                                            return (
                                                                <Grid item className={`${workFlowGlobalStyles.triggerKeywordChip}`}>
                                                                    <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.primaryFontWeight}`}>{value}</Typography>
                                                                </Grid>
                                                            );
                                                        })
                                                        :
                                                        <Grid item className={`${workFlowGlobalStyles.triggerKeywordChip}`}>
                                                            <Typography className={`${globalStyles.secondaryFontSize} ${globalStyles.primaryFontWeight}`}>Hi</Typography>
                                                        </Grid>
                                                    }
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12}>
                                    <Grid container justifyContent={"end"} alignItems={"center"} gap={2}> 
                                        <Grid item>
                                            <GlobalTooltip
                                                placement='top'
                                                title={copyText}
                                                arrow
                                            >
                                                <span className={globalStyles.clickable} onMouseLeave={() => onMouseLeaveOfCopy()}>
                                                    <CopyToClipboard text={qrLink} onCopy={handleCopy}> 
                                                        <Grid item className={globalStyles.clickable} sx={{ pointerEvents: "auto" }}>
                                                            <IconsColor iconName={"Copy"} fillColor="#000" width="18px" height="18px" />
                                                        </Grid>
                                                    </CopyToClipboard>
                                                </span>
                                            </GlobalTooltip>
                                        </Grid>
                                        <Grid item>
                                            <GlobalTooltip
                                                placement='top'
                                                title="Download QR"
                                                arrow
                                            >
                                                <Grid item className={globalStyles.clickable} onClick={downloadQRCode}>
                                                    <IconsColor iconName='download' fillColor="#000" width="25px" height="25px" />
                                                </Grid>
                                            </GlobalTooltip>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item className={globalStyles.clickable}>
                                    <a href={qrLink}
                                        rel="noreferrer"
                                        target='_blank'
                                    >

                                        <div ref={svgRef}>
                                            <QRCode value={qrLink} />
                                        </div>
                                    </a>
                                </Grid>

                            </Grid>
                        </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default QrCodePopup
